import React from 'react';
import { Badge } from '../ui/badge';
import { Trophy, Users } from 'lucide-react';
import { GAME_MODES } from '../../mock/gameData';

const ScoreBoard = ({ gameMode, player1Wins, player2Wins, totalGames, aiInfo }) => {
  return (
    <div className="flex items-center justify-center gap-4 text-white">
      <Badge variant="secondary" className="bg-blue-700 text-white">
        <Trophy className="w-4 h-4 mr-1" />
        {gameMode === GAME_MODES.HUMAN_VS_COMPUTER ? 'You' : 'P1'} Wins: {player1Wins}
      </Badge>
      <Badge variant="secondary" className="bg-purple-700 text-white">
        <Trophy className="w-4 h-4 mr-1" />
        {gameMode === GAME_MODES.HUMAN_VS_COMPUTER ? aiInfo?.name : 'P2'} Wins: {player2Wins}
      </Badge>
      <Badge variant="secondary" className="bg-gray-700 text-white">
        <Users className="w-4 h-4 mr-1" />
        Games: {totalGames}
      </Badge>
    </div>
  );
};

export default ScoreBoard;